import { Provider } from "@redotech/redo-order-common/provider";
import { VariantPage } from "@redotech/redo-product-common/product";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const searchVariantsForProduct = {
  name: "searchVariantsForProduct" as const,
  input: z.object({
    productId: z.string(),
    provider: createEnum(Provider),
    /** Chosen option values by option position; a gap means "any". */
    optionValues: z.array(z.string().optional()).optional(),
    searchText: z.string().optional(),
    first: z.number().optional(),
    after: z.string().optional(),
    countryCode: z.string().optional(),
    includeOptions: z.boolean().optional(),
  }),
  output: VariantPage,
};
